export default __webpack_public_path__ + "static/media/Rubik-ExtraBoldItalic.ffa64246.woff";